import styled from "styled-components";

export const PageContainer = styled.section`
  display: block;
  height: auto;
  background: linear-gradient(to bottom, #172736, #0e1823, #000);
  overflow: hidden;
  color: #fff;
`;
// <{ backgroundUrl: string }>
/* background-image: url(${(props) => props.backgroundUrl}); */
/* background: linear-gradient(to bottom, #f7f5e6, #111e2b */
